import React, { useMemo, useState } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { ButtonExpansionLess, ButtonExpansionMore } from '../../ButtonExpansion';
import type { Skill } from '../types';
import { SkillsGrouped } from './SkillsGrouped';
import { SKILL_GROUPS_SHOWN_BY_DEFAULT_COUNT } from './constants';
import { groupSkills } from './utils/groupSkills';

type SkillsContentProps = Readonly<{
    skills: Skill[];
}>;

export const SkillsContent = ({ skills }: SkillsContentProps) => {
    const [expanded, setExpanded] = useState(false);
    const { groupsShownByDefault, restGroups } = useMemo(() => {
        const allGroups = groupSkills(skills);
        const groupsShownByDefault = allGroups.slice(0, SKILL_GROUPS_SHOWN_BY_DEFAULT_COUNT);
        const restGroups = allGroups.slice(SKILL_GROUPS_SHOWN_BY_DEFAULT_COUNT);

        return {
            groupsShownByDefault,
            restGroups,
        };
    }, [skills]);

    const shouldShowExpansion = restGroups.length > 0;
    const skillsTotalCount = skills.length;

    return (
        <Stack direction="column" alignItems="flexStart">
            <Stack direction="column" gap="8">
                <SkillsGrouped skillGroups={groupsShownByDefault} />
                {expanded && <SkillsGrouped skillGroups={restGroups} />}
            </Stack>

            {shouldShowExpansion && (
                <Container marginTop={expanded ? '8' : '3'}>
                    {expanded ? (
                        <ButtonExpansionLess onClick={() => setExpanded(false)} />
                    ) : (
                        <ButtonExpansionMore onClick={() => setExpanded(true)} totalCount={skillsTotalCount} />
                    )}
                </Container>
            )}
        </Stack>
    );
};
